import { render, staticRenderFns } from "./PlaylistSort.vue?vue&type=template&id=972db45c&scoped=true"
import script from "./PlaylistSort.vue?vue&type=script&lang=ts"
export * from "./PlaylistSort.vue?vue&type=script&lang=ts"
import style0 from "./PlaylistSort.vue?vue&type=style&index=0&id=972db45c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972db45c",
  null
  
)

export default component.exports